export default "__VITE_ASSET__CQYnGmy2__"